import React from 'react';
import cn from 'classnames';
import { ICalendarDate, ICalendarType } from '../../Calendar';
import { calcDaysOfNextMonthInLastWeek, calcDaysOfPrevMonthInFirstWeek, calcMondayDateOfPrevMonthInCurrentView, calcYearAndMonth, generateCalendarViewData, isDateBGreaterThanDateA } from '../../helpers/dateFormatters';
import { ICalendarPosition, ICalendarViewState, weekdays } from '../CalendarView';
import { CalendarViewCell } from './Cell/CalendarViewCell';
require("./CalendarViewCellsGrid.css");
var styles = {
  "Root": "CalendarViewCellsGrid-module-Root_16I",
  "Weekday": "CalendarViewCellsGrid-module-Weekday_1jv"
};
export const CalendarViewCellsGrid = ({
  currentView,
  calendarPosition,
  includeTailsFromOtherMonths,
  selectedDateOne,
  selectedDateTwo,
  selectDatesFrom,
  selectDatesTill,
  disabledDates,
  onClickDate,
  calendarType
}) => {
  const currentViewData = generateCalendarViewData(currentView);
  return /*#__PURE__*/React.createElement("div", {
    "data-position": calendarPosition,
    className: styles.Root
  }, [...weekdays.slice(1, 7), weekdays[0]].map(weekdayName => /*#__PURE__*/React.createElement("div", {
    className: styles.Weekday,
    key: weekdayName
  }, weekdayName)), includeTailsFromOtherMonths ? [...Array(calcDaysOfPrevMonthInFirstWeek(currentViewData.firstWeekdayOfCurrentViewMonth))].map((_, index) => {
    const key = index;
    const value = 1 + index + calcMondayDateOfPrevMonthInCurrentView(currentViewData.daysInPreviousViewMonth, calcDaysOfPrevMonthInFirstWeek(currentViewData.firstWeekdayOfCurrentViewMonth));
    const dateOfCurrentViewBox = {
      ...calcYearAndMonth({
        ...currentView,
        changeMonths: -1
      }),
      day: value
    };
    const isDisabled = Boolean(selectDatesFrom) && isDateBGreaterThanDateA(dateOfCurrentViewBox, selectDatesFrom) || Boolean(selectDatesTill) && isDateBGreaterThanDateA(selectDatesTill, dateOfCurrentViewBox);
    return /*#__PURE__*/React.createElement(CalendarViewCell, {
      dateOfCurrentViewBox: dateOfCurrentViewBox,
      key: key.toString(),
      selectedDateOne: selectedDateOne,
      selectedDateTwo: selectedDateTwo,
      onClick: onClickDate,
      isDisabled: isDisabled
    });
  }) : [...Array(calcDaysOfPrevMonthInFirstWeek(currentViewData.firstWeekdayOfCurrentViewMonth))].map((_, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: cn(styles.Cell, {
        [styles.dateFrom]: 'otherMonth'
      })
    });
  }), [...Array(currentViewData.daysInCurrentViewMonth)].map((_, index) => {
    const key = index + calcDaysOfPrevMonthInFirstWeek(currentViewData.firstWeekdayOfCurrentViewMonth);
    const value = index + 1;
    const dateOfCurrentViewBox = {
      ...currentView,
      day: value
    };
    const isDisabled = Boolean(selectDatesFrom) && isDateBGreaterThanDateA(dateOfCurrentViewBox, selectDatesFrom) || Boolean(selectDatesTill) && isDateBGreaterThanDateA(selectDatesTill, dateOfCurrentViewBox) || disabledDates?.some(disabledDate => !isDateBGreaterThanDateA(dateOfCurrentViewBox, disabledDate) && !isDateBGreaterThanDateA(disabledDate, dateOfCurrentViewBox));
    return /*#__PURE__*/React.createElement(CalendarViewCell, {
      key: key.toString(),
      calendarType: calendarType,
      calendarPosition: calendarPosition,
      dateOfCurrentViewBox: dateOfCurrentViewBox,
      selectedDateOne: selectedDateOne,
      selectedDateTwo: selectedDateTwo,
      onClick: onClickDate,
      hasRoundedEndings: !includeTailsFromOtherMonths,
      isCurrentView: true,
      isDisabled:
      // eslint-disable-next-line no-nested-ternary
      isDisabled !== undefined ? Array.isArray(isDisabled) ? isDisabled.some(Boolean) : isDisabled : false
    });
  }), includeTailsFromOtherMonths ? [...Array(calcDaysOfNextMonthInLastWeek(currentViewData.daysInCurrentViewMonth, currentViewData.daysOfMonthInFirstWeek))].map((_, index) => {
    const key = index + currentViewData.daysOfMonthInFirstWeek + currentViewData.daysInCurrentViewMonth;
    const value = index + 1;
    const dateOfCurrentViewBox = {
      ...calcYearAndMonth({
        ...currentView,
        changeMonths: 1
      }),
      day: value
    };
    const isDisabled = Boolean(selectDatesFrom) && isDateBGreaterThanDateA(dateOfCurrentViewBox, selectDatesFrom) || Boolean(selectDatesTill) && isDateBGreaterThanDateA(selectDatesTill, dateOfCurrentViewBox);
    return /*#__PURE__*/React.createElement(CalendarViewCell, {
      dateOfCurrentViewBox: dateOfCurrentViewBox,
      key: key.toString(),
      selectedDateOne: selectedDateOne,
      selectedDateTwo: selectedDateTwo,
      onClick: onClickDate,
      isDisabled: isDisabled
    });
  }) : [...Array(calcDaysOfNextMonthInLastWeek(currentViewData.daysInCurrentViewMonth, currentViewData.daysOfMonthInFirstWeek))].map((_, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: index + currentViewData.daysOfMonthInFirstWeek + currentViewData.daysInCurrentViewMonth,
      className: cn(styles.Cell, {
        [styles.dateFrom]: 'otherMonth'
      })
    });
  }));
};